import React from 'react';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const HeroContent = () => (
  <div className="max-w-3xl mx-auto text-center">
    <h1 className="text-5xl sm:text-6xl lg:text-8xl font-medium mb-8 text-[#F0EDE8]" data-testid="hero-h1">
      Whisky Woven
    </h1>
    <p className="text-xl sm:text-2xl lg:text-3xl text-[#F0EDE8]/90 mb-4 leading-snug font-medium" data-testid="hero-tagline">
      Cinematic AI images and video trailers for fantasy authors
    </p>
    <p className="text-base sm:text-lg text-[#E8E4DF] mb-14 max-w-xl mx-auto leading-relaxed" data-testid="hero-subtext">
      I create character portraits, world imagery, and dark, immersive visuals that bring your story to life.
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-font="label">
      <button onClick={() => scrollToSection('work')} className="bg-[#14B8A6] hover:bg-[#0D9488] text-[#0A0A0B] font-medium px-8 py-3.5 text-sm uppercase tracking-[0.12em] transition-all duration-300 hover:shadow-lg hover:shadow-[#14B8A6]/20" data-testid="hero-see-work-btn">
        See the work
      </button>
      <button onClick={() => scrollToSection('our-story')} className="border-2 border-[#F0EDE8]/50 text-[#F0EDE8] hover:text-[#14B8A6] hover:border-[#14B8A6]/80 hover:bg-[#14B8A6]/5 font-medium px-8 py-3.5 text-sm uppercase tracking-[0.12em] transition-all duration-300" data-testid="hero-our-story-btn">
        Our Story
      </button>
    </div>
  </div>
);

const Hero = () => (
  <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0">
      <img
        src="https://customer-assets.emergentagent.com/job_cc339f9e-450d-46e0-915d-8c3f1a0f1e38/artifacts/prsfe5kx_hero%20image%203.jpg"
        alt="Cinematic masquerade ballroom scene with fantasy characters and a chocolate labrador"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/70 via-[#0A0A0B]/50 to-[#0A0A0B]" />
    </div>
    <div className="container relative z-10 mx-auto px-6 py-28 lg:py-44">
      <HeroContent />
    </div>
  </section>
);

export default Hero;
